import { DOMController } from "./js/dom-controller";
import "./styles.css";

new DOMController();
